import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { UserService } from '../shared/services/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  token: string;
  resetPasswordForm: FormGroup;
  currentYear: number;
  isSubmitted: number = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    public fb: FormBuilder,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.token = params['token'];
    });

    this.createForm();
  }

  createForm() {
    this.resetPasswordForm = this.fb.group({
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      ],
      repeatPassword: ["", Validators.required]
    },
      {
        validator: this.MatchPassword // your validation method
      });
  }

  MatchPassword(AC: AbstractControl) {
    let password = AC.get("password").value; // to get value in input tag
    let confirmPassword = AC.get("repeatPassword").value; // to get value in input tag
    if (password != confirmPassword) {
      AC.get("repeatPassword").setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  onSubmit(form) {
    if (!this.resetPasswordForm.valid) {
      return;
    }
    this.isSubmitted = 1;
    form.token = this.token;
    this.userService.resetPassword(form).subscribe((res) => {
      this.router.navigate(['/login']);
      this.isSubmitted = 0;
    }, err => {
      this.isSubmitted = 0;
    });
  }

  // passwordConfirming(c: AbstractControl): { invalid: boolean } {
  //   console.log(c);
  //   if (c.get('password').value !== c.get('repeatPassword').value) {
  //     return { invalid: true };
  //   }
  // }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/reset-password/reset-password.component.ts